import React from 'react'
import { NavLink } from '../HeaderStyled';
import { DropdownMenu, DropdownMenuTrigger, RightSlot, StyledContent, StyledItem, StyledSeparator } from './HeaderLanguageStyled';
import { ReactComponent as LanguageIcon } from "assets/Icons/Language.svg";
import { ReactComponent as DropDownIcon } from "assets/Icons/DropDown.svg";

const HeaderLanguageMenu: React.FC = () => {

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger >
                    <LanguageIcon />
                    <NavLink to='/'>EN</NavLink>
                    <DropDownIcon />
                </DropdownMenuTrigger>

                <StyledContent sideOffset={15}>

                    <StyledItem>
                        English <RightSlot>Ctrl + E</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        Chinease <RightSlot>Ctrl + C</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        English <RightSlot>Ctrl + E</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        Chinease <RightSlot>Ctrl + C</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        English <RightSlot>Ctrl + E</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        Chinease <RightSlot>Ctrl + C</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        English <RightSlot>Ctrl + E</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        Chinease <RightSlot>Ctrl + C</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        English <RightSlot>Ctrl + E</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        Chinease <RightSlot>Ctrl + C</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        English <RightSlot>Ctrl + E</RightSlot>
                    </StyledItem>

                    <StyledSeparator />

                    <StyledItem>
                        Chinease <RightSlot>Ctrl + C</RightSlot>
                    </StyledItem>

                </StyledContent>

            </DropdownMenu>
        </>
    )
}

export default HeaderLanguageMenu;